import { render } from "./WordGroupOfTheWeek.vue?vue&type=template&id=4f98e18e"
import script from "./WordGroupOfTheWeek.vue?vue&type=script&lang=js"
export * from "./WordGroupOfTheWeek.vue?vue&type=script&lang=js"

import "./WordGroupOfTheWeek.vue?vue&type=style&index=0&id=4f98e18e&lang=scss"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__